export default "__VITE_ASSET__DrZQUTsF__"